import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CreditCardGroupo icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CreditCardGroupo } from '@sravni/design-system-icons'
 *
 * <CreditCardGroupo />
 * ```
 */
var CreditCardGroupo = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CreditCardGroupo", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M17 17H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M4 10h15M4 14H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v1M10 14H7", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CreditCardGroupo };
//# sourceMappingURL=CreditCardGroupo.js.map
